/**
 * Slugs reserved for app routes - cannot be used as agency slugs.
 * Keep in sync with backend/src/constants/reservedSlugs.ts
 */
const RESERVED_AGENCY_SLUGS = new Set([
  'individual',
  'login',
  'admin',
  'register',
  'privacy',
  'terms',
  'support',
  'plans',
  'demo',
  'checkin',
  'vendor',
  'jobs',
  'contractor',
  'set-password',
  'reset-password',
  'delete-account',
  'contact-sales',
  'api',
  'agencies',
]);

/** Simple slugify for validation - matches backend slugify output for common cases */
function toSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

export function isReservedAgencySlug(slug: string): boolean {
  return RESERVED_AGENCY_SLUGS.has(slug.toLowerCase().trim());
}

export function wouldProduceReservedSlug(agencyName: string): boolean {
  const slug = toSlug(agencyName) || 'individual';
  return isReservedAgencySlug(slug);
}
